import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Blog } from 'src/app/_models/blog';
import blogsData from '../../../_models/blogs.json';

@Component({
  selector: 'app-blogs-details',
  templateUrl: './blogs-details.component.html',
  styleUrls: ['./blogs-details.component.scss']
})
export class BlogsDetailsComponent implements OnInit {

  blogId: number;
  blog: Blog
  blogs: Array<Blog>;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.blogId = +params['id'];
      this.getBlog();
      this.getAllBlogsWithoutCurrentBlog()
    });
    this.blogs = blogsData
  }

  getBlog() {
    blogsData.find((item: Blog) => {
      if (item.id === this.blogId) {
        this.blog = item
      }
    });
  }

  getAllBlogsWithoutCurrentBlog() {
    this.blogs = blogsData
    let res = this.blogs.filter(obj => obj.id !== this.blogId);
    this.blogs = res;
  }

  blogDetailsNavigation(id: number) {
    this.router.navigate(['blogs-details/' + id]);
  }
}
